var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk2712743430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.5 30",
    style: {
      enableBackground: "new 0 0 200.5 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 69.9,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 30.3859 66.3418)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.2953 38.0517)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.4,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8,30H57.1V0.4h29.7V30z M58.2,28.9h27.5V1.5H58.2V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,26H61V4h22.5V26z M62.1,24.8h20.2V5.1H62.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.1,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 18.3117 88.9644)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.4,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 75.2484 172.8781)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.6,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5,30h-29.7V0.4h29.7V30z M171.9,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,26h-22.5V4h22.5V26z M175.3,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 0.1706 15.984)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8768 9.6282)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,30H0V0.4h29.7V30z M1.1,28.9h27.5V1.5H1.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26H3.9V4h22.5V26z M5,24.8h20.2V5.1H5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.8,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 14.9808 75.6375)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 61.0261 148.3131)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2,30h-29.7V0.4h29.7V30z M143.6,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,26h-22.5V4h22.5V26z M147,24.8h20.2V5.1H147V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.6179 62.1824)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.4,
    y: 7.4,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 46.644 123.4904)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.7,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.6,30h-29.7V0.4h29.7V30z M115,28.9h27.5V1.5H115V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.7,26h-22.5V4h22.5V26z M118.4,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.8,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.287 48.8556)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.1,
    y: 7.4,
    transform: "matrix(0.4981 -0.8671 0.8671 0.4981 32.4265 98.9282)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,30H85.5V0.4h29.7V30z M86.7,28.9h27.5V1.5H86.7V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4,26H88.9V4h22.5V26z M90.1,24.8h20.2V5.1H90.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: -6.2,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 15.3207 41.2283)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -5.0762 23.8768)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4,30H28.6V0.4h29.7V30z M29.7,28.9h27.5V1.5H29.7V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,26H32.5V4H55V26z M33.6,24.8h20.2V5.1H33.6V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,28.5l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.7l1.8-4.2c0.1-0.3,0.5-0.4,0.7-0.3c0.3,0.1,0.4,0.5,0.3,0.7l-1.8,4.2 C59.4,28.4,59.2,28.5,59,28.5z M62.1,21.1l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.7l1.8-4.2c0.1-0.3,0.5-0.4,0.7-0.3 c0.3,0.1,0.4,0.5,0.3,0.7l-1.8,4.2C62.5,21,62.3,21.1,62.1,21.1z M65.1,13.8l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.7l1.8-4.2 c0.1-0.3,0.5-0.4,0.7-0.3c0.3,0.1,0.4,0.5,0.3,0.7l-1.8,4.2C65.6,13.6,65.4,13.8,65.1,13.8z M68.2,6.4l-0.2,0 c-0.3-0.1-0.4-0.5-0.3-0.7l1.8-4.2c0.1-0.3,0.5-0.4,0.7-0.3c0.3,0.1,0.4,0.5,0.3,0.7L68.7,6C68.6,6.3,68.4,6.4,68.2,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3,29.6c-0.2,0-0.4-0.1-0.5-0.3l-2.2-4c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l2.2,4 c0.2,0.3,0.1,0.6-0.2,0.8L86.3,29.6z M82.4,22.7c-0.2,0-0.4-0.1-0.5-0.3l-2.2-4c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2 l2.2,4c0.2,0.3,0.1,0.6-0.2,0.8L82.4,22.7z M78.5,15.7c-0.2,0-0.4-0.1-0.5-0.3l-2.2-4c-0.2-0.3-0.1-0.6,0.2-0.8 c0.3-0.2,0.6-0.1,0.8,0.2l2.2,4c0.2,0.3,0.1,0.6-0.2,0.8L78.5,15.7z M74.7,8.7c-0.2,0-0.4-0.1-0.5-0.3l-2.2-4 c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l2.2,4c0.2,0.3,0.1,0.6-0.2,0.8L74.7,8.7z M70.8,1.8c-0.2,0-0.4-0.1-0.5-0.3 l-0.4-0.6c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l0.4,0.6c0.2,0.3,0.1,0.6-0.2,0.8L70.8,1.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk2712743430);
export default __webpack_public_path__ + "static/media/AK2_7_1274343_0.2be87517e5c5e48e11ddeaea4291dfb8.svg";
export { ForwardRef as ReactComponent };